const FETCH_MESSAGES_LIST_REQUEST = 'FETCH_MESSAGES_LIST_REQUEST';
const FETCH_MESSAGES_LIST_FAILURE = 'FETCH_MESSAGES_LIST_FAILURE';
const FETCH_MESSAGES_LIST_SUCCESS = 'FETCH_MESSAGES_LIST_SUCCESS';

const FETCH_MESSAGE_REQUEST = 'FETCH_MESSAGE_REQUEST';
const FETCH_MESSAGE_FAILURE = 'FETCH_MESSAGE_FAILURE';
const FETCH_MESSAGE_SUCCESS = 'FETCH_MESSAGE_SUCCESS';

const FETCH_UNREAD_MESSAGES_COUNT_REQUEST = 'FETCH_UNREAD_MESSAGES_COUNT_REQUEST';
const FETCH_UNREAD_MESSAGES_COUNT_FAILURE = 'FETCH_UNREAD_MESSAGES_COUNT_FAILURE';
const FETCH_UNREAD_MESSAGES_COUNT_SUCCESS = 'FETCH_UNREAD_MESSAGES_COUNT_SUCCESS';

const DELETE_MESSAGES_REQUEST = 'DELETE_MESSAGES_REQUEST';
const DELETE_MESSAGES_FAILURE = 'DELETE_MESSAGES_FAILURE';
const DELETE_MESSAGES_SUCCESS = 'DELETE_MESSAGES_SUCCESS';

const DELETE_MESSAGE_REQUEST = 'DELETE_MESSAGE_REQUEST';
const DELETE_MESSAGE_FAILURE = 'DELETE_MESSAGE_FAILURE';
const DELETE_MESSAGE_SUCCESS = 'DELETE_MESSAGE_SUCCESS';

const DELETE_SENT_MESSAGES_REQUEST = 'DELETE_SENT_MESSAGES_REQUEST';
const DELETE_SENT_MESSAGES_FAILURE = 'DELETE_SENT_MESSAGES_FAILURE';
const DELETE_SENT_MESSAGES_SUCCESS = 'DELETE_SENT_MESSAGES_SUCCESS';

const DELETE_SENT_MESSAGE_REQUEST = 'DELETE_SENT_MESSAGE_REQUEST';
const DELETE_SENT_MESSAGE_FAILURE = 'DELETE_SENT_MESSAGE_FAILURE';
const DELETE_SENT_MESSAGE_SUCCESS = 'DELETE_SENT_MESSAGE_SUCCESS';

const MARK_MESSAGE_AS_UNREAD_REQUEST = 'MARK_MESSAGE_AS_UNREAD_REQUEST';
const MARK_MESSAGE_AS_UNREAD_FAILURE = 'MARK_MESSAGE_AS_UNREAD_FAILURE';
const MARK_MESSAGE_AS_UNREAD_SUCCESS = 'MARK_MESSAGE_AS_UNREAD_SUCCESS';

const MARK_MESSAGE_AS_READ_REQUEST = 'MARK_MESSAGE_AS_READ_REQUEST';
const MARK_MESSAGE_AS_READ_FAILURE = 'MARK_MESSAGE_AS_READ_FAILURE';
const MARK_MESSAGE_AS_READ_SUCCESS = 'MARK_MESSAGE_AS_READ_SUCCESS';

const FETCH_SENT_MESSAGES_LIST_REQUEST = 'FETCH_SENT_MESSAGES_LIST_REQUEST';
const FETCH_SENT_MESSAGES_LIST_FAILURE = 'FETCH_SENT_MESSAGES_LIST_FAILURE';
const FETCH_SENT_MESSAGES_LIST_SUCCESS = 'FETCH_SENT_MESSAGES_LIST_SUCCESS';

const FETCH_RECIPIENTS_REQUEST = 'FETCH_RECIPIENTS_REQUEST';
const FETCH_RECIPIENTS_FAILURE = 'FETCH_RECIPIENTS_FAILURE';
const FETCH_RECIPIENTS_SUCCESS = 'FETCH_RECIPIENTS_SUCCESS';

const REPLY_MESSAGE_REQUEST = 'REPLY_MESSAGE_REQUEST';
const REPLY_MESSAGE_FAILURE = 'REPLY_MESSAGE_FAILURE';
const REPLY_MESSAGE_SUCCESS = 'REPLY_MESSAGE_SUCCESS';

const ADD_MESSAGE_TO_SELECTED = 'ADD_MESSAGE_TO_SELECTED';
const DELETE_MESSAGE_FROM_SELECTED = 'DELETE_MESSAGE_FROM_SELECTED';
const TOGGLE_SELECT_ALL_MESSAGES_POINTER = 'TOGGLE_SELECT_ALL_MESSAGES_POINTER';
const SET_SELECT_ALL_MESSAGES_POINTER = 'SET_SELECT_ALL_MESSAGES_POINTER';
const CLEAR_SELECTED_MESSAGES_LIST = 'CLEAR_SELECTED_MESSAGES_LIST';
const CLEAR_SELECTED_MESSAGE = 'CLEAR_SELECTED_MESSAGE';
const RESET_INBOX = 'RESET_INBOX';

export default {
  FETCH_MESSAGES_LIST_REQUEST,
  FETCH_MESSAGES_LIST_SUCCESS,
  FETCH_MESSAGES_LIST_FAILURE,
  FETCH_MESSAGE_REQUEST,
  FETCH_MESSAGE_SUCCESS,
  FETCH_MESSAGE_FAILURE,
  FETCH_UNREAD_MESSAGES_COUNT_REQUEST,
  FETCH_UNREAD_MESSAGES_COUNT_SUCCESS,
  FETCH_UNREAD_MESSAGES_COUNT_FAILURE,
  DELETE_MESSAGES_REQUEST,
  DELETE_MESSAGES_SUCCESS,
  DELETE_MESSAGES_FAILURE,
  DELETE_MESSAGE_REQUEST,
  DELETE_MESSAGE_SUCCESS,
  DELETE_MESSAGE_FAILURE,
  DELETE_SENT_MESSAGES_REQUEST,
  DELETE_SENT_MESSAGES_SUCCESS,
  DELETE_SENT_MESSAGES_FAILURE,
  DELETE_SENT_MESSAGE_REQUEST,
  DELETE_SENT_MESSAGE_SUCCESS,
  DELETE_SENT_MESSAGE_FAILURE,
  MARK_MESSAGE_AS_UNREAD_REQUEST,
  MARK_MESSAGE_AS_UNREAD_FAILURE,
  MARK_MESSAGE_AS_UNREAD_SUCCESS,
  MARK_MESSAGE_AS_READ_REQUEST,
  MARK_MESSAGE_AS_READ_FAILURE,
  MARK_MESSAGE_AS_READ_SUCCESS,
  FETCH_SENT_MESSAGES_LIST_REQUEST,
  FETCH_SENT_MESSAGES_LIST_SUCCESS,
  FETCH_SENT_MESSAGES_LIST_FAILURE,
  FETCH_RECIPIENTS_REQUEST,
  FETCH_RECIPIENTS_SUCCESS,
  FETCH_RECIPIENTS_FAILURE,
  REPLY_MESSAGE_REQUEST,
  REPLY_MESSAGE_FAILURE,
  REPLY_MESSAGE_SUCCESS,
  ADD_MESSAGE_TO_SELECTED,
  DELETE_MESSAGE_FROM_SELECTED,
  TOGGLE_SELECT_ALL_MESSAGES_POINTER,
  SET_SELECT_ALL_MESSAGES_POINTER,
  CLEAR_SELECTED_MESSAGES_LIST,
  CLEAR_SELECTED_MESSAGE,
  RESET_INBOX,
};



// WEBPACK FOOTER //
// ./src/modules/message/actions/action-types.js